import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import AppContext from "../../../context/app/context";
import ScaleContext from "../../../context/scale/context";
import ScaleContextProvider from "../../../context/scale/provider";
import { useIsMount } from "../../../utils/hooks/is-mount";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import SearchFilterCard from "../../general/filter-card";
import PageHeader from "../../general/layout/page-header";
import RefreshBtn from "../../general/table-components/actions/refresh-btn";
import ScaleMovementsFilter from "./scale-movements-filter";
import ScaleMovementsTable from "./scale-movements-table";
import styles from "./style.module.scss";

interface IProps {
  children?: React.ReactNode;
}

const ScaleMovementsComponent: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const { id } = useParams();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { details, movementsQuery, actions, loading } =
    useContext(ScaleContext);

  useEffect(() => {
    id && actions.getDetails(Number(id));
  }, [direction, id]);

  useEffect(() => {
    actions.setMovementsQuery({
      ...movementsQuery,
      page: INITIAL_PAGE,
      keyword: search,
    });
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && id && actions.getMovements(Number(id));
  }, [movementsQuery, direction]);

  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("scale_movements")}
        subTitle={
          details ? `${details?.name} - ${details?.store?.name ?? ""}` : ""
        }
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("movements")}
            onClick={() => actions.getMovements(Number(id))}
          >
            {t("refresh")}
          </RefreshBtn>,
        ]}
      />
      <SearchFilterCard
        formId="scale-movements-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setMovementsQuery({
            page: movementsQuery?.page,
            perPage: movementsQuery?.perPage,
          });
          const form = document.getElementById("scale-movements-filter");
          if (form) {
            form.dispatchEvent(
              new Event("reset", { cancelable: true, bubbles: true })
            );
          }
        }}
        resetLoading={loading.includes("movements")}
        applyLoading={loading.includes("movements")}
      >
        <ScaleMovementsFilter />
      </SearchFilterCard>

      <ScaleMovementsTable />
    </div>
  );
};

const ScaleMovementsPage = () => {
  return (
    <ScaleContextProvider>
      <ScaleMovementsComponent />
    </ScaleContextProvider>
  );
};

export default ScaleMovementsPage;
